import React, { useEffect, useState } from 'react';
import Reaptcha from 'reaptcha';
import { useRecoilState } from 'recoil';
import ReactTooltip from "react-tooltip";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";

import Toastify from "~/components/Toastify";
import api from '~/services/api';

import { mensagemConformidadeLGPD } from '../../atoms/conformidade';

import { Container, Title, Disclaimer, ContainerEtapa, ContainerOpcoesClicaveis, OpcaoClicavel, ContainerFicha, ItemFicha } from './stylesAgendamento';
import { Select, TextArea, ButtonPadraoPrimary, Input, SpanErrorForm, } from '~/styles/CommonStyles';

function Agendamento ( { location } ) {
    const params = new URLSearchParams( location.search );
    const _CHAVE = params.get( 'chave' );
    const { handleSubmit, register, errors, control, watch, getValues, triggerValidation, setValue } = useForm();
    const [ recaptchaToken, setRecaptchaToken ] = useState( null );
    const [ conformidadeMensagem, setConformidadeMensagem ] = useRecoilState( mensagemConformidadeLGPD );

    useEffect( () => {
        if ( !_CHAVE )
            return Toastify.error( 'Erro, chave ou questionario inexistente, por favor entre em contato com medico para que seja enviado um novo link' );
    }, [ recaptchaToken ] );

    const onSubmit = async ( values ) => {
        console.log( values );
    };

    return (
        <Container onSubmit={ handleSubmit( onSubmit ) }>
            <Title>Agendamento online</Title>
            <Disclaimer>
                Alguma descrição ou area aonde a clinica pode deixar um texto de observação para aparecer ao paciente.
            </Disclaimer>
            <ContainerEtapa>
                <h3>1. Preencha seus dados</h3>
                <ContainerFicha>
                    <ItemFicha>
                        <span>Nome:</span>
                        <Input name="Nome" defaultValue={ '' } ref={ register( { required: "Campo obrigatório", } ) } invalido={ errors.Nome } />
                        { errors.Nome && <SpanErrorForm>{ errors.Nome.message }</SpanErrorForm> }
                    </ItemFicha>
                    <ItemFicha>
                        <span>Idade:</span>
                        <Input name="Idade" defaultValue={ '' } ref={ register( { required: "Campo obrigatório", } ) } invalido={ errors.Idade } />
                        { errors.Idade && <SpanErrorForm>{ errors.Idade.message }</SpanErrorForm> }
                    </ItemFicha>
                    <ItemFicha>
                        <span>Email:</span>
                        <Input name="Email" type="email" defaultValue={ '' } ref={ register( { required: "Campo obrigatório", pattern: /^\S+@\S+$/i } ) } invalido={ errors.Email } />
                        { errors.Email && <SpanErrorForm>{ errors.Email.message }</SpanErrorForm> }
                    </ItemFicha>
                    <ItemFicha>
                        <span>Celular:</span>
                        <Input name="Celular" type="Celular" defaultValue={ '' } ref={ register( { required: "Campo obrigatório", } ) } invalido={ errors.Celular } />
                        { errors.Celular && <SpanErrorForm>{ errors.Celular.message }</SpanErrorForm> }
                    </ItemFicha>
                </ContainerFicha>
            </ContainerEtapa>
            <ContainerEtapa>
                <h3>2. Escolha um(a) dr(a)</h3>
                <Select>
                    <option>Carlos</option>
                    <option>Artur</option>
                    <option>Leandro</option>
                </Select>
            </ContainerEtapa>
            <ContainerEtapa>
                <h3>3. Escolha um dia</h3>
                <ContainerOpcoesClicaveis>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="03/02" i ref={ register } />
                        <span>03/02</span>
                    </OpcaoClicavel>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="04/02" ref={ register } />
                        <span>04/02</span>
                    </OpcaoClicavel>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="05/02" ref={ register } />
                        <span>04/02</span>
                    </OpcaoClicavel>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="06/02" ref={ register } />
                        <span>04/02</span>
                    </OpcaoClicavel>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="07/02" ref={ register } />
                        <span>04/02</span>
                    </OpcaoClicavel>
                </ContainerOpcoesClicaveis>
            </ContainerEtapa>
            <ContainerEtapa>
                <h3>4. Escolha um horário</h3>
                <ContainerOpcoesClicaveis>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="03/02" i ref={ register } />
                        <span>03:02</span>
                    </OpcaoClicavel>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="04/02" ref={ register } />
                        <span>04:02</span>
                    </OpcaoClicavel>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="05/02" ref={ register } />
                        <span>04:02</span>
                    </OpcaoClicavel>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="06/02" ref={ register } />
                        <span>04:02</span>
                    </OpcaoClicavel>
                    <OpcaoClicavel >
                        <input name="radioDia" type="radio" value="07/02" ref={ register } />
                        <span>04:02</span>
                    </OpcaoClicavel>
                </ContainerOpcoesClicaveis>
            </ContainerEtapa>
            <ContainerEtapa>
                <h3>5. Deixe uma observação no agendamento</h3>
                <div>
                    <TextArea></TextArea>
                </div>
            </ContainerEtapa>
            <div style={ { display: 'flex', justifyContent: 'center', margin: '10px 0px' } }>
                <Reaptcha
                    sitekey="6LfrDqgZAAAAABATEykmT5tqdYVnvx0B7Fm3Ahj3"
                    onVerify={ ( value ) => setRecaptchaToken( value ) }
                    onExpire={ () => setRecaptchaToken( null ) }
                />

            </div>
            <div style={ { display: 'flex', justifyContent: 'center', margin: '0px 0px 10px 0px' } }>
                <a data-tip data-for='btnHome' >
                    <ButtonPadraoPrimary type="submit" disabled={ !recaptchaToken } >Salvar Agendamento</ButtonPadraoPrimary>
                </a>
                <ReactTooltip delayShow={ 300 } id='btnHome' place="bottom" type="dark" effect="solid">
                    { recaptchaToken ? <span>Salvar Agendamento</span> : <span>Antes selecione o captcha de verificação (Não sou o robô)</span> }
                </ReactTooltip>

            </div>
        </Container>
    );
}

export default Agendamento;
